import React from 'react'
import { Router, Redirect, Route, IndexRedirect } from 'react-router'

import { render } from 'react-dom'
import { Provider } from 'react-redux'
import Store from './store'
import { loadLoginInfo, login, doAuthentication } from './actions/LoginAction'
import {loggedIn, getRoles} from './utils/AuthHelper'

import history from './components/layout/navigation/classes/History.js'

import Layout from './pages/layout/Layout.js'
import Login from './components/login/Login';
import Home from './pages/Home';
import Unauthorized from './pages/Unauthorized';

import PushNotification from './pages/notification/Notification.js'
import NotificationList from './pages/notification/NotificationList.js'
import ContactManage from './pages/board/Contact.js'

import DbReportItemNew from './pages/dbreport/ItemRegister';
import DBReportItemUnique from './pages/dbreport/ItemUniqueRegister'
import DbReportShopSearchHitrate from './pages/dbreport/ShopSearchHitrate';

import MemberEparkLoginUser from './pages/member/MemberEparkLoginUser';

import UserVoiceContact from './pages/uservoice/Contact';
import UserVoiceRequest from './pages/uservoice/Request';

import DBReportItemEparkRegister from './pages/dbreport/ItemEparkRegister'
import DbReportItemEparkUniqueRegister from './pages/dbreport/ItemEparkUniqueRegister';

import MonetizeBooking from './pages/monetize/MonetizeBooking'

import {UsercardBreakdown, UsercardCount, BookingCount} from './pages/collectdata'

const store = Store()
store.dispatch(doAuthentication());

const requireAuth = (nextState, replace) => {

    if(!loggedIn()){
        store.dispatch(login());
    }else{
      store.dispatch(loadLoginInfo());
    }

}

const requireAdminAuth = (nextState, replace) => {

  let roles = getRoles();
  if(roles.indexOf('admin') == -1){
    replace({ pathname: '/unauthorized' })
  }

}

render(
  <Provider store={store}>
    <Router history={history}>

      <Route path="/" component={Layout}>
        <IndexRedirect to="/home" />

        <Route path="home" component={Home} onEnter={requireAuth}/>

        <Redirect from="notification" to="/notification/notification_push"/>
        <Route path="notification" >
          <Route path="notification_push" component={PushNotification} onEnter={requireAdminAuth}/>
          <Route path="notification_list" component={NotificationList} onEnter={requireAdminAuth}/>
        </Route>

        <Redirect from="datacollect" to="/datacollect/user_card_breakdown"/>
        <Route path="datacollect" >
          <Route path="user_card_breakdown" component={UsercardBreakdown} onEnter={requireAdminAuth}/>
          <Route path="user_card_count" component={UsercardCount} onEnter={requireAdminAuth}/>
          <Route path="booking_count" component={BookingCount} onEnter={requireAdminAuth}/>
        </Route>

        <Redirect from="db_report" to="/db_report/item"/>
        <Route path="db_report" >
          <Route path="item_register" component={DbReportItemNew} onEnter={requireAdminAuth}/>
          <Route path="item_register_unique" component={DBReportItemUnique} onEnter={requireAdminAuth}/>
          <Route path="item_register_epark" component={DBReportItemEparkRegister} onEnter={requireAdminAuth}/>
          <Route path="item_register_unique_epark" component={DbReportItemEparkUniqueRegister} onEnter={requireAdminAuth}/>
          <Route path="shop_search_hitrate" component={DbReportShopSearchHitrate} onEnter={requireAdminAuth}/>
          <Route path="booking_count" component={BookingCount} onEnter={requireAdminAuth}/>
        </Route>

        <Redirect from="monetize" to="/monetize/booking"/>
        <Route path="monetize" >
          <Route path="booking" component={MonetizeBooking} onEnter={requireAdminAuth}/>
        </Route>

        <Redirect from="member" to="/member/epark_login_user"/>
        <Route path="member" >
          <Route path="epark_login_user" component={MemberEparkLoginUser} onEnter={requireAdminAuth}/>
        </Route>

        <Redirect from="uservoice" to="/uservoice/request"/>
        <Route path="uservoice" >
          <Route path="request" component={UserVoiceRequest} onEnter={requireAdminAuth}/>
          <Route path="contact" component={UserVoiceContact} onEnter={requireAdminAuth}/>
          <Route path="contact_manage" component={ContactManage} onEnter={requireAdminAuth}/>
        </Route>

        <Route path="unauthorized" component={Unauthorized} />
        <Route path="login" component={Login} />
        <Route path="logout" component={Home} onEnter={requireAuth}/>

      </Route>

  </Router>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js